import React from 'react';
import { Stack } from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { ArrowBackIcon, DataGrid, Loader } from '@orijinworks/frontend-commons';
import { AuditHeader, DataGridWrapper, RoundIconButton } from './Audit.styles';
import { AuditUpdatedByTypographySX, NavyMainTypography } from '../../Feeds.style';
import { useAuditHook } from './useAuditHook';
import { AuditToggleButton } from './AuditToggleButton';
import DeleteModal from '../../../../shared/components/DeleteModal/DeleteModal';
import { Link } from 'react-router-dom';
import { FeedDrawer } from '../../../../shared/components/feed-drawer';

const Audit = () => {
    const { columns,
        modalRef,
        data,
        pageSize,
        loading,
        exportLoading,
        selectedType,
        totalRecordsCount,
        onFilterChangeHandler,
        onTypeChangeHandler,
        handleSelectedChangeHandler,
        refreshContactsHandler,
        onPageChangeHandler,
        onPageSizeChangeHandler,
        onSortChangeHandler,
        onTogglaModalHandlerHandler,
        onContinueDeleteModalHandlerHandler,
        handleBackClick,
        getModalTitle,
        getModalDescription,
        getFeedDrawerProps,
        handleExportCurrentView,
    } = useAuditHook();
   
    return (
        <>
            <Loader isLoading={exportLoading} />
            <Stack
                height="100%"
                backgroundColor="white"
                direction="column" spacing={2}>
                <AuditHeader>
                <Stack
                    padding={"20px"}
                    direction="row" spacing={2} alignItems="center">
                    <RoundIconButton 
                    LinkComponent={Link}
                    onClick={handleBackClick}
                    variant="contained" color="primary">
                        <ArrowBackIcon />
                    </RoundIconButton>
                    <Stack>
                        <NavyMainTypography variant="h1">
                            Audit Log
                        </NavyMainTypography>
                    </Stack>
                </Stack>
            </AuditHeader>
            <DataGridWrapper className={selectedType}>
                {columns.length > 0 && (
                    <DataGrid
                        columns={columns}
                        data={[...data]}
                        pageSize={pageSize}
                        pageSizeOptions={[5, 10, 25, 50]}
                        paginationMode={'server'}
                        isLoading={loading}
                        onSelectionChange={handleSelectedChangeHandler}
                        showClearSelectionButton={true}
                        serverSidePaginationProps={{
                            onPageChange: onPageChangeHandler,
                            onPageSizeChange: onPageSizeChangeHandler,
                            onSortChange: onSortChangeHandler,
                            onFilterChange: onFilterChangeHandler,
                            totalRecordsCount
                        }}
                        onRefreshHandler={refreshContactsHandler}
                        hasActionColumn={true}
                        secondaryButtonProps={selectedType !== 'Feed-History' ? {
                            text: 'Export Current View',
                            startIcon: <SaveAltIcon color='#0F48B8' />,
                            onClick: handleExportCurrentView,
                            variant: 'outlined',
                          } : false}
                        headerStartComponent={<AuditToggleButton isDisabled={loading} selectedType={selectedType} onTypeChange={onTypeChangeHandler} />}
                        tdStyles={{
                            createdAt: {
                                width: 100,
                            },
                            recipient: {
                                width: 250,
                            },
                            sender: {
                                width: 250,
                            },
                            isDeleted: {
                                width: 110,
                            },
                            performedBy: AuditUpdatedByTypographySX,
                            adminName: {
                                width: 200
                            },
                            actionTypes: {
                                width: 164
                            },
                            dateOfLastAction: {
                                width: 100
                            },
                            statuses: {
                                width: 140
                            },
                            learner: {
                                width: 360
                            }
                        }}
                    />
                )}
            </DataGridWrapper>
            <DeleteModal
                modalRef={modalRef}
                title={getModalTitle()}
                description={getModalDescription()}
                open={false}
                onClose={onTogglaModalHandlerHandler}
                onContinue={onContinueDeleteModalHandlerHandler}
            />
            <FeedDrawer {...getFeedDrawerProps()} />
        </Stack>
        </>
    );
};

export default Audit;
